/**
 * Export Section — thin wrapper around DataExportCard.
 */

import { SeatUpgradeCard } from '@/components/seat-gate/SeatUpgradeCard';
import { useFeatureAccess } from '@/hooks/usePermissions';
import { useViewHealthMarker } from '@/lib/view-health';

import { DataExportCard } from '../../profile/components/DataExportCard';

export function ExportSection() {
  useViewHealthMarker('settings-section-ready');
  // CRM export is a seat feature: a read-only seat gets the paywall here,
  // not three export buttons that 403 (feature_gated) at the backend.
  const { hasFeature } = useFeatureAccess();
  const canExport = hasFeature('crm_export');
  return (
    <div className='space-y-8'>
      <div>
        <h2 className='text-lg font-semibold text-fg-primary'>Export</h2>
        <p className='text-sm text-fg-tertiary mt-0.5'>
          Download your CRM data as CSV files.
        </p>
      </div>
      <div>
        {canExport ? (
          <DataExportCard />
        ) : (
          <div className='max-w-md'>
            <SeatUpgradeCard feature='crm_export' variant='full' />
          </div>
        )}
      </div>
    </div>
  );
}
